<template>
  <!-- Card View Skeleton -->
  <div v-if="viewMode === 'card'" class="education-card-skeleton">
    <div class="course-path-card mb-2">
      <div class="skeleton-image"></div>
      <div class="course-path-card-contents">
        <div class="course-card-info d-flex justify-content-between mb-2">
          <div class="skeleton-category"></div>
        </div>
        <div class="skeleton-title mb-3"></div>
        <div class="skeleton-button mb-2"></div>
        <div class="skeleton-progress mb-2"></div>
        <div class="skeleton-date"></div>
      </div>
      <div class="course-path-card-footer">
      </div>
    </div>
  </div>

  <!-- List View Skeleton -->
  <div v-else class="education-card-skeleton-list">
    <div class="course-path-card-list mb-3">
      <div class="course-list-image">
        <div class="skeleton-image-list"></div>
      </div>
      <div class="course-list-content">
        <div class="course-list-header">
          <div class="course-list-meta">
            <div class="skeleton-category"></div>
          </div>
          <div class="course-list-header-right">
            <div class="skeleton-time"></div>
          </div>
        </div>
        <div class="skeleton-title-list mb-3"></div>
        <div class="skeleton-button mb-2"></div>
        <div class="skeleton-progress"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationCardSkeleton",
  props: {
    viewMode: {
      type: String,
      default: 'card',
      validator: (value) => ['card', 'list'].includes(value)
    }
  }
};
</script>

<style scoped>
/* No pulse animation — loading shimmer is sufficient. Double animation wastes GPU layers. */

/* Card View Skeleton Styles */
.education-card-skeleton .course-path-card {
  background: #fff;
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.skeleton-image {
  width: 100%;
  height: 120px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 14px 14px 0 0;
}

.skeleton-category {
  width: 100px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 50%;
}

.skeleton-title {
  width: 80%;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-button {
  width: 120px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-progress {
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-date {
  width: 150px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-rating {
  width: 100px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

/* List View Skeleton Styles */
.course-path-card-list {
  display: flex;
  align-items: stretch;
  background: white;
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-height: 150px;
}

.course-list-image {
  flex: 0 0 35%;
  min-width: 35%;
  overflow: hidden;
  background: #f0f0f0;
}

.skeleton-image-list {
  width: 100%;
  height: 100%;
  min-height: 150px;
  background: linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

.course-list-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  min-width: 0;
}

.course-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.course-list-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.course-list-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.skeleton-category {
  width: 100px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-time {
  width: 140px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title-list {
  width: 60%;
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}

.skeleton-button {
  width: 140px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}

.skeleton-progress {
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* GPU-accelerate skeleton shimmer animations */
.skeleton-image,
.skeleton-category,
.skeleton-icon,
.skeleton-title,
.skeleton-button,
.skeleton-progress,
.skeleton-date,
.skeleton-rating,
.skeleton-image-list,
.skeleton-time,
.skeleton-title-list {
  will-change: background-position;
}

/* Responsive */
@media (max-width: 960px) {
  .course-path-card-list {
    flex-direction: column;
  }

  .course-list-image {
    flex: 0 0 auto;
    width: 100%;
    min-width: 100%;
  }

  .skeleton-image-list {
    height: 200px;
    min-height: 200px;
  }

  .course-list-content {
    padding: 16px;
  }
}

@media (max-width: 640px) {
  .skeleton-image-list {
    height: 150px;
    min-height: 150px;
  }

  .course-list-content {
    padding: 12px;
  }

  .course-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .course-list-header-right {
    width: 100%;
    justify-content: space-between;
  }

  .skeleton-title-list {
    width: 90%;
  }
}
</style>

